import { Button, LoadPanel, Tooltip } from "devextreme-react";
import React, { useEffect, useRef, useState } from "react";
import "./QueryPanel.scss";
import CustomButton from "../../../../components/customButton/CustomButton";
import CustomHtmlEditor from "../../../../components/customHtmlEditor/CustomHtmlEditor";
import ReplyIcon from "../../../../assets/Reply-icon.svg";
import HtmlEditor, { Toolbar, Item } from "devextreme-react/html-editor";
import { getTicketActivities, saveReply } from "../../../../api/ticketApi";
import { ToastDisplayer } from "../../../../components/toastDisplay/ToastDisplayer";

export default function QueryPanel({
  detailTicketData,
  getTicketDetails,
  isTicketClosed,
}) {
  const [markup, setMarkup] = useState("");
  const [showEditor, setShowEditor] = useState(false);
  const [savedReplies, setSavedReplies] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [showAllReplies, setShowAllReplies] = useState(false);
  const [greeting, setGreeting] = useState("Greetings");

  const fileInputRef = useRef(null);
  const editorRef = useRef(null);
  const replyListRef = useRef(null);
  const editorContainerRef = useRef(null);

  useEffect(() => {
    if (showEditor) {
      setTimeout(() => {
        const editor = editorRef.current?.instance;

        if (editor) {
          if (!editor.option("value")) {
            editor.option("value", `<p>${greeting},</p><p></p>`);
          }

          editor.focus();

          // 🔥 MOVE CURSOR TO END
          const selection = editor.getSelection();
          const length = editor.getLength();

          editor.setSelection(length, 0);
        }

        editorContainerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 0);
    }
  }, [showEditor]);

  useEffect(() => {
    if (showAllReplies && replyListRef.current) {
      setTimeout(() => {
        replyListRef.current.scrollTo({
          top: replyListRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 100);
    }
  }, [showAllReplies, savedReplies]);

  useEffect(() => {
    const handleImageClick = (e) => {
      if (e.target.tagName === "IMG") {
        const src = e.target.getAttribute("src");
        if (!src) return;

        const newWindow = window.open("", "_blank");

        if (newWindow) {
          newWindow.document.write(`
          <html>
            <head>
              <title>Image Preview</title>
              <style>
                body {
                  margin: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                  background: #000;
                }
                img {
                  max-width: 100%;
                  max-height: 100%;
                }
              </style>
            </head>
            <body>
              <img src="${src}" />
            </body>
          </html>
        `);
          newWindow.document.close();
        }
      }
    };

    document.addEventListener("click", handleImageClick);

    return () => {
      document.removeEventListener("click", handleImageClick);
    };
  }, []);
  useEffect(() => {
    fetchReplies();
  }, [detailTicketData]);

  // function downloadAttachment(base64String, fileName) {
  //   if (!base64String) {
  //     console.error("No file data available");
  //     return;
  //   }

  //   const match = base64String.match(/^data:(.*?);base64,/);
  //   if (!match) {
  //     console.error("Invalid Base64 format");
  //     return;
  //   }

  //   const mimeType = match[1];
  //   const allowedMimeTypes = {
  //     "image/png": "png",
  //     "image/jpeg": "jpg",
  //     "image/jpg": "jpg",
  //     "application/pdf": "pdf",
  //   };
  //   const extension = allowedMimeTypes[mimeType];
  //   if (!extension) {
  //     console.error("Unsupported file type");
  //     return;
  //   }

  //   const fullFileName = `${fileName}.${extension}`; // Construct the filename

  //   const byteCharacters = atob(base64String.split(",")[1]);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: mimeType });

  //   // Create a download link and trigger download
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = fullFileName;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  function downloadAttachment(base64String, fileName) {
    if (!base64String) {
      console.error("No file data available");
      return;
    }

    let mimeType = "application/octet-stream";
    let base64Data = base64String;

    // If API sends full data URL
    if (base64String.startsWith("data:")) {
      const arr = base64String.split(",");
      mimeType = arr[0].match(/:(.*?);/)[1];
      base64Data = arr[1];
    }

    const allowedMimeTypes = {
      "image/png": "png",
      "image/jpeg": "jpg",
      "image/jpg": "jpg",
      "application/pdf": "pdf",
      "video/mp4": "mp4",
    };

    const extension = allowedMimeTypes[mimeType] || "file";

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const fetchReplies = async () => {
    try {
      const ticketcode = detailTicketData?.ticket?.ticketcode;
      if (!ticketcode) return;

      const response = await getTicketActivities(ticketcode);

      const replies = response?.data?.replies || [];

      const formattedReplies = replies.map((item, index) => ({
        id: index,
        text: item.replydescription,
        createdBy: item.replycreatedby,
        role: item.replyrole,
        date: item.replydatetime,
        attachments: item.attachments || [],
      }));

      // 🔥 SORT: Oldest first → latest goes to bottom
      const sortedReplies = formattedReplies.sort(
        (a, b) => new Date(a.date) - new Date(b.date),
      );

      setSavedReplies(sortedReplies);
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };

  const handleSendReply = async () => {
    const editor = editorRef.current.instance;
    const markup = editor.option("value") || "";
    if (isSending) return;

    const cleanedHtml = markup
      .replace(/white-space:\s*pre[^;]*;/gi, "white-space: normal;")
      .replace(/<pre[^>]*>/gi, "<div>")
      .replace(/<\/pre>/gi, "</div>")
      .replace(/<p><br><\/p>/gi, "")
      .replace(/<p>\s*<\/p>/gi, "");

    const plainText = cleanedHtml.replace(/<[^>]*>/g, "").trim();

    if (!plainText && attachedFiles.length > 0) {
      ToastDisplayer(
        "error",
        "Description is mandatory when attaching a file",
        "warning",
        3000,
      );
      return;
    }

    if (!plainText && attachedFiles.length === 0) {
      ToastDisplayer("error", "Please enter description", "warning", 3000);
      return;
    }

    const attachments = attachedFiles.map((file) => ({
      filename: file.name,
      filedata: file.base64.split(",")[1], // remove data:image/png;base64,
    }));

    const payload = {
      ticketcode: detailTicketData?.ticket?.ticketcode,
      replydescription: cleanedHtml,
      attachments: attachments,
    };

    try {
      setIsSending(true);

      await saveReply(payload);

      ToastDisplayer("success", "Reply sent successfully");

      setAttachedFiles([]);
      editor.option("value", "");
      setShowEditor(false);
      getTicketDetails();
      fetchReplies();
    } catch (error) {
      console.error("Error saving reply:", error);

      ToastDisplayer("error", "Failed to send reply");
    } finally {
      setIsSending(false);
    }
  };

  // const handleFileSelect = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     const base64 = reader.result;

  //     const newFile = {
  //       file,
  //       name: file.name,
  //       base64,
  //       type: file.type,
  //     };

  //     setAttachedFiles([newFile]);
  //   };

  //   reader.readAsDataURL(file);

  //   e.target.value = "";
  // };

  const MAX_TOTAL_SIZE = 25 * 1024 * 1024; // 25 MB

  const ALLOWED_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png",
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".xlsx",
    ".mp4",
  ];

  const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const existingSize = attachedFiles.reduce(
      (sum, f) => sum + (f.file?.size || 0),
      0,
    );

    let totalNewSize = 0;
    const validFiles = [];

    for (const file of files) {
      const ext = "." + file.name.split(".").pop().toLowerCase();

      // Validate extension
      if (!ALLOWED_EXTENSIONS.includes(ext)) {
        ToastDisplayer("error", `${file.name} is not a supported file type`);
        continue;
      }

      totalNewSize += file.size;
      validFiles.push(file);
    }

    // Validate total size
    if (existingSize + totalNewSize > MAX_TOTAL_SIZE) {
      ToastDisplayer("error", "Total attachment size cannot exceed 20 MB");
      e.target.value = "";
      return;
    }

    const filesWithBase64 = await Promise.all(
      validFiles.map(
        (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () =>
              resolve({
                file,
                name: file.name,
                base64: reader.result,
                type: file.type,
              });

            reader.onerror = reject;

            reader.readAsDataURL(file);
          }),
      ),
    );

    setAttachedFiles((prev) => [...prev, ...filesWithBase64]);

    e.target.value = "";
  };
  const removeFile = (index) => {
    setAttachedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // function viewAttachment(base64String) {
  //   if (!base64String) {
  //     ToastDisplayer("error", "No attachment available");
  //     return;
  //   }

  //   let fileSrc = base64String;

  //   // Detect file type if API sends only raw base64
  //   if (!base64String.startsWith("data:")) {
  //     if (base64String.startsWith("/9j/")) {
  //       fileSrc = `data:image/jpeg;base64,${base64String}`;
  //     } else if (base64String.startsWith("iVBOR")) {
  //       fileSrc = `data:image/png;base64,${base64String}`;
  //     } else if (base64String.startsWith("JVBER")) {
  //       fileSrc = `data:application/pdf;base64,${base64String}`;
  //     } else {
  //       fileSrc = `data:application/octet-stream;base64,${base64String}`;
  //     }
  //   }

  //   const isImage = fileSrc.includes("image");

  //   const newWindow = window.open("", "_blank");

  //   newWindow.document.write(`
  // <html>
  //   <head>
  //     <title>Attachment</title>
  //     <style>
  //       body{
  //         margin:0;
  //         display:flex;
  //         justify-content:center;
  //         align-items:center;
  //         height:100vh;
  //         background:#f5f5f5;
  //       }
  //       iframe{
  //         width:100%;
  //         height:100%;
  //         border:none;
  //       }
  //       img{
  //         max-width:100%;
  //         max-height:100%;
  //       }
  //     </style>
  //   </head>
  //   <body>
  //     ${isImage
  //       ? `<img src="${fileSrc}" />`
  //       : `<iframe src="${fileSrc}"></iframe>`
  //     }
  //   </body>
  // </html>
  // `);

  //   newWindow.document.close();
  // }

  // function viewAttachment(base64String, fileName = "attachment") {
  //   if (!base64String) {
  //     ToastDisplayer("error", "No attachment available");
  //     return;
  //   }

  //   let fileSrc = base64String;
  //   let mimeType = "application/octet-stream";
  //   let base64Data = base64String;

  //   // Helper: download function
  //   const downloadFile = (data, type, ext) => {
  //     const byteCharacters = atob(data);
  //     const byteNumbers = new Array(byteCharacters.length);

  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }

  //     const blob = new Blob([new Uint8Array(byteNumbers)], { type });

  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${fileName}.${ext}`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   };

  //   // Detect file type if API sends raw base64
  //   if (!base64String.startsWith("data:")) {
  //     if (base64String.startsWith("/9j/")) {
  //       mimeType = "image/jpeg";
  //       fileSrc = `data:${mimeType};base64,${base64String}`;
  //     } else if (base64String.startsWith("iVBOR")) {
  //       mimeType = "image/png";
  //       fileSrc = `data:${mimeType};base64,${base64String}`;
  //     } else if (base64String.startsWith("JVBER")) {
  //       mimeType = "application/pdf";
  //       fileSrc = `data:${mimeType};base64,${base64String}`;
  //     } else if (
  //       base64String.startsWith("AAAA") ||
  //       base64String.includes("ftyp")
  //     ) {
  //       mimeType = "video/mp4";
  //       downloadFile(base64String, mimeType, "mp4");
  //       return;
  //     } else if (base64String.startsWith("UEsDB")) {
  //       mimeType =
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  //       downloadFile(base64String, mimeType, "xlsx");
  //       return;
  //     } else if (
  //       base64String.startsWith("SGVsbG8") ||
  //       /^[A-Za-z0-9+/=\r\n]+$/.test(base64String)
  //     ) {
  //       mimeType = "text/plain";
  //       fileSrc = `data:${mimeType};base64,${base64String}`;
  //     } else {
  //       fileSrc = `data:application/octet-stream;base64,${base64String}`;
  //     }
  //   }

  //   const isImage = fileSrc.includes("image");
  //   const isPDF = fileSrc.includes("pdf");
  //   const isText = mimeType.includes("text");

  //   if (!isImage && !isPDF && !isText) {
  //     downloadFile(base64Data, mimeType, fileName.split(".").pop() || "file");
  //     return;
  //   }
  //   //   const newWindow = window.open("", "_blank");

  //   //   newWindow.document.write(`
  //   // <html>
  //   //   <head>
  //   //     <title>Attachment</title>
  //   //     <style>
  //   //       body{
  //   //         margin:0;
  //   //         display:flex;
  //   //         justify-content:center;
  //   //         align-items:center;
  //   //         height:100vh;
  //   //         background:#f5f5f5;
  //   //       }
  //   //       iframe{
  //   //         width:100%;
  //   //         height:100%;
  //   //         border:none;
  //   //       }
  //   //       img{
  //   //         max-width:100%;
  //   //         max-height:100%;
  //   //       }
  //   //     </style>
  //   //   </head>
  //   //   <body>
  //   //    ${
  //   //      isImage
  //   //        ? `<img src="${fileSrc}" />`
  //   //        : isPDF
  //   //          ? `<iframe src="${fileSrc}"></iframe>`
  //   //          : mimeType.includes("text")
  //   //            ? `<pre style="
  //   //           padding:20px;
  //   //           font-family: monospace;
  //   //           white-space: pre-wrap;
  //   //           background:#f9fafb;
  //   //         ">
  //   //           ${atob(base64Data)}
  //   //         </pre>`
  //   //            : `<script>
  //   //           const link = document.createElement('a');
  //   //           link.href = '${fileSrc}';
  //   //           link.download = '${fileName}';
  //   //           document.body.appendChild(link);
  //   //           link.click();
  //   //         </script>
  //   //         <p>Downloading file...</p>`
  //   //    }
  //   //   </body>
  //   // </html>
  //   // `);

  //   //   newWindow.document.close();
  // }
  function viewAttachment(base64String, fileName = "attachment") {
    if (!base64String) {
      ToastDisplayer("error", "No attachment available");
      return;
    }

    let mimeType = "application/octet-stream";
    let base64Data = base64String;
    let fileSrc = base64String;

    // ✅ Normalize base64
    if (base64String.startsWith("data:")) {
      const arr = base64String.split(",");
      mimeType = arr[0].match(/:(.*?);/)[1];
      base64Data = arr[1];
      fileSrc = base64String;
    } else {
      if (base64String.startsWith("/9j/")) {
        mimeType = "image/jpeg";
      } else if (base64String.startsWith("iVBOR")) {
        mimeType = "image/png";
      } else if (base64String.startsWith("JVBER")) {
        mimeType = "application/pdf";
      } else if (base64String.startsWith("UEsDB")) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (
        base64String.startsWith("AAAA") ||
        base64String.includes("ftyp")
      ) {
        mimeType = "video/mp4";
      }

      fileSrc = `data:${mimeType};base64,${base64String}`;
    }

    const isImage = mimeType.includes("image");

    // 🔥 IMAGE → OPEN IN NEW WINDOW
    if (isImage) {
      const newWindow = window.open("", "_blank");

      newWindow.document.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            body {
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background: #000;
            }
            img {
              max-width: 100%;
              max-height: 100%;
            }
          </style>
        </head>
        <body>
          <img src="${fileSrc}" />
        </body>
      </html>
    `);

      newWindow.document.close();
      return;
    }

    // 🔥 ALL OTHER FILES → DOWNLOAD
    const extensionMap = {
      "application/pdf": "pdf",
      "video/mp4": "mp4",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
    };

    const ext = extensionMap[mimeType] || "file";

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.${ext}`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  const visibleReplies = showAllReplies ? savedReplies : savedReplies.slice(-1);
  const hiddenCount = savedReplies.length - 1;

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const descriptionHtml = detailTicketData?.ticket?.ticketdescription || "";

  // Extract pasted images
  // const pastedImages = [
  //   ...descriptionHtml.matchAll(/<img[^>]+src="([^">]+)"/g),
  // ].map((match, index) => ({
  //   filename: `Pasted Image ${index + 1}`,
  //   filedata: match[1],
  // }));

  // Get API attachments
  const apiAttachments = detailTicketData?.ticket?.attachments || [];

  // 🔥 Merge both
  const allAttachments = [...apiAttachments];

  // Clean description (remove inline images)
  const cleanDescription = descriptionHtml.replace(/<img[^>]*>/gi, "");

  // 🔥 ROLE LOGIC (ADD THIS)
  const getReplyType = (role) => {
    const r = role?.toLowerCase()?.trim();

    if (["companyuser", "company"].includes(r)) return "agent";
    if (["customercontact", "customer"].includes(r)) return "client";

    return "client";
  };

  return (
    <div className="querySec">
      <div className="queryMain ticket-card">
        {" "}
        <div className="ticket-subject">
          <b>{`${detailTicketData?.ticket?.ticketsubject || ""}`}</b>
        </div>
        <div className="queryInner">
          <div className="description-wrapper">
            <div
              className="description-content"
              dangerouslySetInnerHTML={{
                __html: descriptionHtml,
              }}
            />
          </div>
        </div>
        {/* {detailTicketData?.ticket?.ticketattachedfile && (
          <div className="file-download">
            <button
              className="detail-small-bold"
              onClick={() =>
                downloadAttachment(
                  detailTicketData?.ticket?.ticketattachedfile,
                  `${detailTicketData?.ticket?.customer_name}_Ticket`
                )
              }
            >
              Download Attachment
            </button>
          </div>

          <Button
            text="Attachment"
            stylingMode="contained"
            icon="download"
            className="download-attachment"
            onClick={() =>
              downloadAttachment(
                detailTicketData?.ticket?.ticketattachedfile,
                `${detailTicketData?.ticket?.customer_name}_Ticket`,
              )
            }
          />
          <Button
            text="Preview Attachment"
            stylingMode="contained"
            // icon="find"
            className="download-attachment"
            onClick={() =>
              viewAttachment(detailTicketData?.ticket?.ticketattachedfile)
            }
          />
        )} */}
      </div>
      {allAttachments.length > 0 && (
        <div className="attachment-list">
          {allAttachments.map((file, index) => (
            <div
              key={index}
              className="reply-attachment-item"
              onClick={() => viewAttachment(file.filedata)}
            >
              <i className="dx-icon dx-icon-attach"></i>
              <span className="attachment-name">
                {file.filename || `Attachment ${index + 1}`}
              </span>
            </div>
          ))}
        </div>
      )}
      <div className="reply-section">
        {savedReplies.length > 0 && (
          // <div className="reply-list">
          //   {savedReplies.map((reply) => {
          //     const imgMatch = reply.text?.match(/<img[^>]+src="([^">]+)"/);
          //     const pastedImage = imgMatch ? imgMatch[1] : null;

          //     return (
          //       <div className="reply-item" key={reply.id}>
          //         <div
          //           className="reply-text"
          //           dangerouslySetInnerHTML={{ __html: reply.text }}
          //         />

          //         {reply.attachment && (
          //           <Button
          //             text="View Attachment"
          //             stylingMode="text"
          //             className="reply-attachment-link"
          //             onClick={() => viewAttachment(reply.attachment)}
          //           />
          //         )}

          //         {!reply.attachment && pastedImage && (
          //           <Button
          //             text="View Attachment"
          //             stylingMode="text"
          //             className="reply-attachment-link"
          //             onClick={() => viewAttachment(pastedImage)}
          //           />
          //         )}
          //       </div>
          //     );
          //   })}
          // </div>
          <div className="reply-list" ref={replyListRef}>
            {/* {hiddenCount > 0 && !showAllReplies && (
              <div
                className="collapsed-replies"
                onClick={() => setShowAllReplies(true)}
              >
                <span className="reply-count">{hiddenCount}</span>
                <div className="collapsed-line"></div>
              </div>
            )} */}
            {/* 🔽 COLLAPSED VIEW (expand) */}
            {hiddenCount > 0 && !showAllReplies && (
              <div
                className="collapsed-replies"
                onClick={() => setShowAllReplies(true)}
              >
                <span className="reply-count">{hiddenCount}</span>
                <div className="collapsed-line"></div>
              </div>
            )}

            {/* 🔼 EXPANDED VIEW (collapse) */}
            {showAllReplies && savedReplies.length > 1 && (
              <div
                className="collapsed-replies"
                onClick={() => setShowAllReplies(false)}
              >
                <span className="reply-count">-</span>
                <div className="collapsed-line"></div>
              </div>
            )}

            {visibleReplies.map((reply) => {
              const replyType = getReplyType(reply.role);
              const cleanReplyText = reply.text;

              return (
                <div
                  className={`reply-item ${
                    replyType === "agent" ? "agent-reply" : "client-reply"
                  }`}
                  key={reply.id}
                >
                  <div className="reply-header">
                    <span className="reply-by">{reply?.createdBy}</span>
                    <span className="reply-date">
                      {formatDateTime(reply?.date)}
                    </span>
                  </div>

                  <div className="reply-left">
                    <div
                      className="reply-text"
                      dangerouslySetInnerHTML={{ __html: cleanReplyText }}
                    />

                    {reply.attachments?.map((file, i) => (
                      <div
                        key={i}
                        className="reply-attachment-item"
                        onClick={() => viewAttachment(file.filedata)}
                      >
                        <i className="dx-icon dx-icon-attach"></i>
                        <span className="attachment-name">{file.filename}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* <div className="reply-action-bar">
        <Button
          text={"Reply"}
          stylingMode="outlined"
          className="reply-button"
          onClick={() => setShowEditor(!showEditor)}
        />
      </div> */}
      {!showEditor && (
        <div className="reply-collapsed-bar">
          <span
            className="placeholder-text"
            onClick={() => {
              if (!isTicketClosed) setShowEditor(true);
            }}
          >
            {isTicketClosed
              ? "Replying is not allowed for closed Tickets"
              : "Type your response here"}
          </span>

          <Button
            className="reply-inline-btn"
            onClick={() => setShowEditor(true)}
            disabled={isTicketClosed}
          >
            <i className="dx-icon dx-icon-message"></i>
            Reply
          </Button>
        </div>
      )}

      {showEditor && (
        <div className="notesMainDrawer-query">
          <div className="notesDrawerDesc">
            <div className="notesItem">
              <div className="descSecQuery">
                <div
                  className="editorWrapper editor-container"
                  ref={editorContainerRef}
                >
                  <LoadPanel visible={isSending} />
                  {/* <Button
                    icon="close"
                    stylingMode="text"
                    className="editor-cancel-btn"
                    onClick={() => {
                      setShowEditor(false);
                      setMarkup("");
                    }}
                  /> */}
                  <HtmlEditor
                    ref={editorRef}
                    height={300}
                    stylingMode="outlined"
                    placeholder="Type your response here"
                    disabled={isSending}
                  >
                    <Toolbar>
                      <Item name="bold" />
                      <Item name="italic" />
                      <Item name="underline" />
                      <Item name="link" />
                      <Item name="orderedList" />
                      <Item name="bulletList" />
                      <Item name="codeBlock" />
                      <Item
                        widget="dxButton"
                        options={{
                          icon: "attach",
                          hint: "Attach File",
                          stylingMode: "text",
                          onClick: () => fileInputRef.current.click(),
                        }}
                      />
                    </Toolbar>
                  </HtmlEditor>
                  <div className="attachedFilesContainer">
                    <div className="attachedFilesList">
                      <div className="fileLimitInfo">
                        <i
                          id="fileInfoIcon"
                          className="dx-icon dx-icon-info"
                        ></i>

                        <Tooltip
                          target="#fileInfoIcon"
                          showEvent="mouseenter click"
                          hideEvent="mouseleave"
                          position="top"
                        >
                          <div className="fileLimitTooltip">
                            Allowed: JPG, PNG, PDF, DOC, DOCX, TXT, XLSX, MP4{" "}
                            <br />
                            Max total size: 20 MB
                          </div>
                        </Tooltip>
                      </div>

                      {attachedFiles.length === 0
                        ? ""
                        : attachedFiles.map((file, index) => (
                            <div key={index} className="attachedFileItem">
                              <span className="fileName">{file.name}</span>

                              <i
                                className="ri-close-line removeFileIcon"
                                onClick={() => removeFile(index)}
                              />
                            </div>
                          ))}
                    </div>
                  </div>
                  <div className="editor-footer">
                    <div className="bottom-buttons">
                      <Button
                        text={isSending ? "Sending..." : "Send"}
                        stylingMode="contained"
                        className="editor-save-btn"
                        onClick={handleSendReply}
                        disabled={isSending}
                        icon={isSending ? "spinright" : undefined}
                      />
                      <Button
                        text={"Cancel"}
                        className="editor-cancel-btn"
                        onClick={() => {
                          setShowEditor(false);
                          setAttachedFiles([]);

                          // clear editor content safely
                          if (editorRef.current?.instance) {
                            editorRef.current.instance.option("value", "");
                          }
                        }}
                      />
                    </div>
                  </div>

                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileSelect(e)}
                    multiple={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
